import {
  ADD_APPOINTMENT,
  GET_DOCTOR_APPOINTMENTS,
  GET_APPOINTMENT,
} from "./AppointmentActions";

const initialState = {
  appointments: [],
  appointment: null,
  appointmentDetails: null,
};

const AppointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCTOR_APPOINTMENTS:
      return Object.assign({}, state, {
        appointments: action.appointments,
      });
    case ADD_APPOINTMENT:
      return Object.assign({}, state, {
        appointments: action.appointments,
      });

    case GET_APPOINTMENT:
      return {
        ...state,
        appointmentDetails: action.appointment,
      };
    default:
      return state;
  }
};

export default AppointmentReducer;
